<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        <el-form-item label="用户id">
          <el-input
            size="small"
            v-model="searchForm.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select
            size="small"
            v-model="searchForm.pay"
            placeholder="请选择"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item, index) in [
                {
                  label: '已支付',
                  value: 'yes',
                },
                {
                  label: '未支付',
                  value: 'no',
                },
              ]"
              :key="index"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="user_id" label="用户id" width="90">
            <template slot-scope="scope">
              {{ scope.row.user.user_id }}
            </template>
          </el-table-column>
          <el-table-column prop="cart_id" label="盒柜ID"></el-table-column>
          <el-table-column prop="product_id" label="商品名称" min-width="140">
            <template slot-scope="scope">
              {{scope.row.product.product_name}}
            </template>
          </el-table-column>

          <el-table-column prop="product_id" label="商品id"> </el-table-column>
          <el-table-column prop="spec_sku_id" label="商品规格">
          </el-table-column>
          <el-table-column prop="join_price" label="加入价格"></el-table-column>
          <el-table-column prop="source_type" label="类型">
            <template slot-scope="scope">
              {{ getSourceType(scope.row.source_type) }}
            </template>
          </el-table-column>
          <el-table-column prop="is_pay" label="是否支付">
            <template slot-scope="scope">
              {{ scope.row.is_pay ? "已支付" : "未支付" }}
            </template>
          </el-table-column>
          <el-table-column prop="draw_card_way" label="抽卡方式">
            <template slot-scope="scope">
              {{ scope.row.draw_card_way ? "积分" : "点券" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
            min-width="140"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            min-width="140"
            label="更新时间"
          ></el-table-column>
          <el-table-column prop="is_pay" label="付款状态">
            <template slot-scope="scope">
              {{ scope.row.is_pay ? "已付款" : "未付款" }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import OrderApi from "@/api/order.js";
import qs from "qs";
export default {
  components: {},
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        order_no: "",
        style_id: "",
        store_id: "",
        create_time: "",
      },
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.ordercartlist(Params, true)
        .then((res) => {
          if (res) {
            self.tableData = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
            self.loading = false;
          }
        })
        .catch((error) => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    },
    getSourceType(type) {
      let str = "";
      switch (type) {
        case 0:
          str = "点券商城";
          break;
        case 1:
          str = "兑换添加";
          break;
        case 2:
          str = "积分商城";
          break;
        case 3:
          str = "抽卡机";
          break;

        default:
          break;
      }
      return str;
    },
  },
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/box/box/index.vue